import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NoOpEncoder_getInstance2wgh00a9s97su as NoOpEncoder_getInstance } from '../internal/NoOpEncoder.mjs';
import {
  encodeNotNullMark352dnk5r97tvq as encodeNotNullMark,
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeSerializableValue1mu7jsn2oheqi as encodeSerializableValue,
  encodeNullableSerializableValue22qo2euy9x1r4 as encodeNullableSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from './Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractEncoderClass;
function AbstractEncoder() {
  if (AbstractEncoderClass === VOID) {
    class $ {
      static r1r() {
        return createThis(this);
      }
      y1q(descriptor) {
        return this;
      }
      z1q(descriptor) {
      }
      s1r(descriptor, index) {
        return true;
      }
      t1r(value) {
        throw SerializationException().c1o('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
      }
      u1r() {
        throw SerializationException().c1o("'null' is not supported by default");
      }
      v1r(value) {
        return this.t1r(value);
      }
      w1r(value) {
        return this.t1r(value);
      }
      x1r(value) {
        return this.t1r(value);
      }
      y1r(value) {
        return this.t1r(value);
      }
      z1r(value) {
        return this.t1r(value);
      }
      a1s(value) {
        return this.t1r(value);
      }
      b1s(value) {
        return this.t1r(value);
      }
      c1s(value) {
        return this.t1r(new (Char())(value));
      }
      d1s(value) {
        return this.t1r(value);
      }
      e1s(enumDescriptor, index) {
        return this.t1r(index);
      }
      f1s(descriptor) {
        return this;
      }
      g1s(descriptor, index, value) {
        if (this.s1r(descriptor, index)) {
          this.v1r(value);
        }
      }
      h1s(descriptor, index, value) {
        if (this.s1r(descriptor, index)) {
          this.w1r(value);
        }
      }
      i1s(descriptor, index, value) {
        if (this.s1r(descriptor, index)) {
          this.x1r(value);
        }
      }
      j1s(descriptor, index, value) {
        if (this.s1r(descriptor, index)) {
          this.y1r(value);
        }
      }
      k1s(descriptor, index, value) {
        if (this.s1r(descriptor, index)) {
          this.z1r(value);
        }
      }
      l1s(descriptor, index, value) {
        if (this.s1r(descriptor, index)) {
          this.a1s(value);
        }
      }
      m1s(descriptor, index, value) {
        if (this.s1r(descriptor, index)) {
          this.b1s(value);
        }
      }
      n1s(descriptor, index, value) {
        if (this.s1r(descriptor, index)) {
          this.c1s(value);
        }
      }
      o1s(descriptor, index, value) {
        if (this.s1r(descriptor, index)) {
          this.d1s(value);
        }
      }
      p1s(descriptor, index) {
        return this.s1r(descriptor, index) ? this.f1s(descriptor.k1p(index)) : NoOpEncoder_getInstance();
      }
      q1s(descriptor, index, serializer, value) {
        if (this.s1r(descriptor, index)) {
          this.r1s(serializer, value);
        }
      }
      s1s(descriptor, index, serializer, value) {
        if (this.s1r(descriptor, index)) {
          this.t1s(serializer, value);
        }
      }
    }
    protoOf($).u1s = encodeNotNullMark;
    protoOf($).v1s = beginCollection;
    protoOf($).r1s = encodeSerializableValue;
    protoOf($).t1s = encodeNullableSerializableValue;
    protoOf($).w1s = shouldEncodeElementDefault;
    initMetadataForClass($, 'AbstractEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    AbstractEncoderClass = $;
  }
  return AbstractEncoderClass;
}
//region block: exports
export {
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
};
//endregion

//# sourceMappingURL=AbstractEncoder.mjs.map
